// src/features/clinical/pages/PatientRegistrationPage.jsx
import React from 'react';
import PatientRegistration from '../components/patient/PatientRegistration';

const PatientRegistrationPage = () => {
  return (
    <div className="max-w-7xl mx-auto px-4">
      <PatientRegistration />
    </div>
  );
};

export default PatientRegistrationPage;